import React, { useEffect, useState } from "react";
import { Layout, Row, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { FetchLandingPageAction, FetchUserAccessAction } from "../../redux/action/LandingPageAction";
import { getUserClaims } from "../../utils/auth/unified-auth";
import { useAuth } from "../../utils/auth/useAuth";
import { LoadingSpinner, Switcher, Icon, Button, CardV2, DataTable, Modal, AccordionItemV2 } from "pepsico-ds";
import CommodityPageHeader from "../../components/Header/CommodityPageHeader";
import { call7DaysNpsLogic } from "../../utils/utils";
import SectorSitesBanner from '../../assets/SectorSitesBanner.svg'
import { useLoginEffects } from "../WalkmeTour/UseLoginEffects";
import { FetchEMEASectorSiteCardAction, FetchOneNASectorSiteCardAction, FetchGlobalPackagingSectorSiteCardAction, FetchSupplierPassportSectorSiteCardAction } from "../../redux/action/SectorSitesAction";
import { localStoreKeys } from '../../constants/localStoreKeys';
import { setKeyValue } from "../../redux/reducer/localDataSlice";

const { Content } = Layout;

function SectorSiteCard({ portalData }) {
    return (
        <Col xs={12} sm={12} md={12} lg={12} xl={8}>
            <CardV2
                cardBody={{
                    isDark: false,
                    slot: (
                        <div
                            style={{
                                minHeight: "150px",
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                fontFamily: 'Inter'
                            }}
                        >
                            <div className="card-title-container">
                                <div className="card-title" style={{ color: "#2d2d2d", lineHeight: "28px" }}>{portalData?.name}</div>
                                <div className="card-description" style={{ display: "flex", height: "70px" }}>
                                    <div style={{ color: "#4B4B4B", fontSize: "14px", lineHeight: "20px" }}>
                                        <div className="sector-sites-emea-card-subtext">
                                            {portalData?.description}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}
                                className="app-card-footer"
                            >
                                <Button
                                    className=""
                                    iconTrailing="open_in_new"
                                    size="large"
                                    style={{}}
                                    text={"Open"}
                                    variant="secondary"
                                    onClick={function clickButton() {
                                        if (portalData?.url) {
                                            window.open(portalData.url, "_blank");
                                        }
                                    }}
                                    data-fs={`${portalData?.name}-external-app-link`}
                                    aria-label={`${portalData?.name}-external-app-link`}
                                />
                            </div>
                        </div>
                    ),
                    type: 'slot',
                }}
                className='sector-site'
                maxScrollHeight="90px"
                state="interactive"
                style={{}}
                type="basic"
                viewport="desktop"
            />
        </Col>
    );
}

function SectorSites() {
    const dispatch = useDispatch();
    const { authState } = useAuth();
    const [userInfo, setUserInfo] = useState({});
    const [sectorSiteEMEACardData, setSectorSiteEMEACardData] = useState({});
    const [sectorSiteNACardData, setSectorSiteNACardData] = useState({});
    const [sectorSiteGlobalPackagingCardData, setSectorSiteGlobalPackagingCardData] = useState({});
    const [sectorSiteSupplierPassportCardData, setSectorSiteSupplierPassportCardData] = useState({});
    const [isDataLoading, setIsDataLoading] = useState(true);
    const [isUserDataFetched, setIsUserDataFetched] = useState(false);
    const [isLoader, setIsLoader] = useState(false);

    const userData = useSelector((state) => state.getLandingPageReducer);
    const userAccessData = useSelector((state) => state.getUserAccessReducer);

    const hasEMEAAccess = userData?.isEMEAUser;
    const hasNaSectorAccess = userAccessData?.isNaSector;
    const hasGlobalPackagingAccess = userAccessData?.isGlobalPackagingUser;
    const hasSupplierPassportAccess = userAccessData?.isSupplierPassportUser;

    const EMEASectorSiteCardApiData = useSelector((state) => state.getEMEASectorSiteCardReducer);
    const NASectorSiteCardApiData = useSelector((state) => state.getOneNASectorSiteCardReducer);
    const GlobalPackagingSectorSiteCardApiData = useSelector((state) => state.getGlobalPackagingSectorSiteCardReducer);
    const SupplierPassportSectorSiteCardApiData = useSelector((state) => state.getSupplierPassportSectorSiteCardReducer);

    useLoginEffects(userData);
     
    useEffect(() => {
        async function fetchUserInfo() {
            const user = await getUserClaims();
            if (user) {
                setUserInfo(user);
                dispatch(FetchLandingPageAction(user));
                dispatch(FetchUserAccessAction(user));
                setIsUserDataFetched(true);
                setIsLoader(true);
            }
        }
        setIsDataLoading(true);
        fetchUserInfo();
    }, []);
     
    useEffect(() => {
        if (isUserDataFetched && userData && userData?.type === "SUCCESS_LANDING_PAGE_ACTION") {
            call7DaysNpsLogic(dispatch, userData);
            setIsDataLoading(false);
            setIsUserDataFetched(false);
            if(hasEMEAAccess) {
                dispatch(FetchEMEASectorSiteCardAction());
            }
            if(hasNaSectorAccess) {
                dispatch(FetchOneNASectorSiteCardAction());
            }
            if(hasGlobalPackagingAccess) {
                dispatch(FetchGlobalPackagingSectorSiteCardAction());
            }
            if(hasSupplierPassportAccess) {
                dispatch(FetchSupplierPassportSectorSiteCardAction());
            }
            if (!hasEMEAAccess && !hasNaSectorAccess && !hasSupplierPassportAccess && !hasGlobalPackagingAccess) { //  
                setIsLoader(false);
            }
        }
        }, [userData, isUserDataFetched, hasEMEAAccess, hasNaSectorAccess, hasSupplierPassportAccess, hasGlobalPackagingAccess]);
     
    useEffect(() => {
        const isEMEASuccess = EMEASectorSiteCardApiData?.type === "SUCCESS_EMEA_SECTOR_SITE_CARD_ACTION";
        const isNASuccess = NASectorSiteCardApiData?.type === "SUCCESS_NA_SECTOR_SITE_CARD_ACTION";
        const isGlobalPackagingSuccess = GlobalPackagingSectorSiteCardApiData?.type === "SUCCESS_GLOBAL_PACKAGING_SECTOR_SITE_CARD_ACTION";
        const isSupplierPassportSuccess = SupplierPassportSectorSiteCardApiData?.type === "SUCCESS_SUPPLIER_PASSPORT_SECTOR_SITE_CARD_ACTION";

        if (isEMEASuccess) {
            setSectorSiteEMEACardData(EMEASectorSiteCardApiData);
        }

        if (isNASuccess) {
            setSectorSiteNACardData(NASectorSiteCardApiData);
        }

        if (isGlobalPackagingSuccess) {
            setSectorSiteGlobalPackagingCardData(GlobalPackagingSectorSiteCardApiData);
        }

        if (isSupplierPassportSuccess) {
            setSectorSiteSupplierPassportCardData(SupplierPassportSectorSiteCardApiData);
        }

        if (isLoader && (isEMEASuccess || isNASuccess || isGlobalPackagingSuccess || isSupplierPassportSuccess)) {
            setIsLoader(false);
        }
    }, [EMEASectorSiteCardApiData, NASectorSiteCardApiData, GlobalPackagingSectorSiteCardApiData, SupplierPassportSectorSiteCardApiData, isLoader]);
   
    
    if (authState?.isAuthenticated) {
        return (
            <Layout>
                <div style={{ display: "flex" }}>
                    <Content style={{ padding: "0 30px 30px 100px", background: "#D7E5F8", minHeight: "125vh" }}>
                        {Object.keys(userInfo)?.length === 0 ? (
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "calc(100vh - 64px)" }}>
                                <LoadingSpinner size={{ height: "80px", width: "80px" }} />
                            </div>
                        ) : (
                            <>
                                {isUserDataFetched || isLoader ? (
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "calc(100vh - 64px)" }}>
                                        <LoadingSpinner size={{ height: "80px", width: "80px" }} />
                                    </div>
                                ) : (
                                    hasEMEAAccess || hasNaSectorAccess || hasGlobalPackagingAccess || hasSupplierPassportAccess ? (
                                        <div>
                                        {/* Banner */}
                                        <CommodityPageHeader 
                                            header={"Global / Sector Links"}
                                            subtext={"Access global and regional procurement portals, supplier information, tools, and frequently used resources in one place."}
                                            // subtext={"A structured directory of sector portals, organized by region with curated links and frequently used resources for quick navigation."}
                                            image={SectorSitesBanner}
                                            pageName={"SectorSites"}
                                        />

                                        <Row gutter={[20, 20]}>
                                            {hasEMEAAccess && (
                                                <SectorSiteCard portalData={sectorSiteEMEACardData?.sectorSpecificPortalData?.[0]} />
                                            )}
                                            {hasNaSectorAccess && (
                                                <SectorSiteCard portalData={sectorSiteNACardData?.sectorSpecificPortalData?.[0]} />
                                            )}
                                            {hasSupplierPassportAccess && (
                                                <SectorSiteCard portalData={sectorSiteSupplierPassportCardData?.sectorSpecificPortalData?.[0]} />
                                            )}
                                            {hasGlobalPackagingAccess && (
                                                <SectorSiteCard portalData={sectorSiteGlobalPackagingCardData?.sectorSpecificPortalData?.[0]} />
                                            )}
                                        </Row>
                                        
                                    </div>
                                    )  : hasEMEAAccess === false && hasNaSectorAccess === false && hasGlobalPackagingAccess === false && hasSupplierPassportAccess === false && hasGlobalPackagingAccess === false ? (
                                        <>
                                            <div  className="landing_page_title">User does not have access to this page</div>
                                        </>
                                    ) : <></>
                                    
                                )}
                            </>
                        )}
                    </Content>
                </div>
            </Layout>
        );
    }
    
    return null;
}

export default SectorSites;